<script setup lang="ts">
import { computed, defineProps, useAttrs } from 'vue';

import DefaultSelect from '../components/DefaultSelect.vue';
import ItemLabel from '../components/ItemLabel.vue';

import type { ProductItem } from '../utils/types';

const props = defineProps<{
  item: ProductItem;
}>();

const $attrs = useAttrs();

const error = computed(() => {
  const product = props.item.products.find((p) => p.id === $attrs.modelValue);

  if (!product) {
    return undefined;
  }

  if (product.is_archived) {
    return 'Wybrany produkt został zarchiwizowany';
  }

  if (!product.is_available) {
    return 'Wybrany produkt nie jest dostępny';
  }

  return undefined;
});
</script>

<template>
  <div class="space-y-11" :class="$attrs.class">
    <DefaultSelect
      v-bind="$attrs"
      :options="
        item.products.filter(
          (product) =>
            (!product.is_archived && product.is_available) || product.id === $attrs.modelValue
        )
      "
      placeholder="Wybierz produkt"
      optionLabel="name"
      optionValue="id"
      filter
      :text-wrap="true"
      :error="error"
    >
      <ItemLabel :item="item" />
    </DefaultSelect>
  </div>
</template>
